import type { ProductGovernance } from 'models/streaming';
import type { CostAndCharge } from 'models/streaming/costsAndCharges';
import type { IRegulatoryRejection, IRegulatoryResource } from 'state/regulatoryDocuments';
import type { Collection } from 'state/utils/types';

export type QuoteRegulationInfos = Readonly<{
  costAndCharge?: CostAndCharge[];
  theoreticalValue?: CostAndCharge[];
  costAndChargeReceived: boolean;

  kidDocument?: IRegulatoryResource[];
  kidDocumentError?: IRegulatoryRejection[];
  kidDocumentTimeout: boolean;
  termsheetDocument?: IRegulatoryResource[];
  termsheetDocumentError?: IRegulatoryRejection[];
  termsheetDocumentTimeout: boolean;

  kidExpected: boolean;

  productGovernanceAssessment?: ProductGovernance;
  productGovernanceAssessmentTimeout: boolean;

  productGovernanceDocumentation?: IRegulatoryResource[];
  productGovernanceDocumentationError?: IRegulatoryRejection[];
  productGovernanceDocumentationTimeout: boolean;
}>;

export const initialRegulationInfos: QuoteRegulationInfos = {
  kidDocumentTimeout: false,
  kidExpected: false,
  costAndChargeReceived: false,
  productGovernanceAssessmentTimeout: false,
  productGovernanceDocumentationTimeout: false,
  termsheetDocumentTimeout: false,
};

export type QuoteRegulationInfosMap = Collection<Collection<QuoteRegulationInfos>>;
